import axios from "@/api/axiosInstance";
import { GetBillingSubscriptionMetadataResponse } from "./types";

export const getBillingSubscriptionMetadata = async (
  id: string,
  signal?: AbortSignal,
): Promise<GetBillingSubscriptionMetadataResponse> => {
  const response = await axios.get<GetBillingSubscriptionMetadataResponse>(
    `/api/private/billing/subscriptions/${id}/metadata`,
    { signal },
  );
  return response.data;
};